function initArticleContent(container = document) {
  const articleContent = container.querySelector(".article-container .article-body .article-content");

  moveArticleBannerMobile();

  if (!articleContent) return;

  replaceTableBadge(articleContent);
  replaceRatingsCard(articleContent);
  replaceProductCard(articleContent);
  productSetIframeStyleInject(articleContent);
}

function moveArticleBannerMobile() {
  const articleBannerMobile = document.querySelector(".article-banner-mobile");
  const breadcrumbs = document.querySelector(".snippet-breadcrumbs");

  if (!articleBannerMobile || !breadcrumbs) return;

  breadcrumbs.parentNode.insertBefore(articleBannerMobile, breadcrumbs);
}

document.addEventListener("DOMContentLoaded", () => {
  initArticleContent(document);
});

document.addEventListener("shopify:section:load", (event) => {
  initArticleContent(event.target);
});

function replaceProductCard(articleContent) {
  let articleCardContent = document.getElementById("article-card_content")?.value || "";

  const shortcodeRegex = /\[product\s+handle="(.*?)"(?:\s+rating="(.*?)")?(?:\s+slogan="(.*?)")?\]/g;
  const contentHtml = articleContent.innerHTML;

  const loadingHtml = contentHtml.replace(shortcodeRegex, (match, handle, rating, slogan) => {
    return `<div class="product-card-placeholder"
                   data-product-handle="${handle}"
                   data-product-rating="${rating || "5"}"
                   data-product-slogan="${slogan || ""}">loading...</div>`;
  });
  articleContent.innerHTML = loadingHtml;

  const placeholders = articleContent.querySelectorAll(".product-card-placeholder");
  placeholders.forEach((placeholder) => {
    const handle = placeholder.getAttribute("data-product-handle");
    const shortcodeRating = placeholder.getAttribute("data-product-rating");
    const slogan = placeholder.getAttribute("data-product-slogan");
    fetchProductData(handle, shortcodeRating, placeholder, slogan);
  });

  function fetchProductData(handle, shortcodeRating, placeholder, slogan) {
    fetch(`/products/${handle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error("The product does not exist.");
        return response.json();
      })
      .then(async (product) => {
        const badgeHtml = await getJudgeBadge(handle);
        placeholder.innerHTML = renderProductCard(product, shortcodeRating, slogan, badgeHtml);
        bindAddToCartEvents(placeholder, product);
      })
      .catch((error) => {
        const errorMsg = `Product loading failed: ${error.message}`;
        placeholder.innerHTML = `<div class="product-card-error">${errorMsg}</div>`;
      });
  }

  function renderProductCard(product, shortcodeRating, slogan, badgeHtml) {
    const variant = product.variants?.[0] || product;
    const imageUrl = product.featured_image || "";
    const rating = shortcodeRating ? parseFloat(shortcodeRating) : 5;
    const starObj = { rating: rating };
    const starsHtml = generateStarsHtml(starObj.rating);
    const formatMoney = (amount, format) => {
      if (!amount) return "$0.00";
      const price = (amount / 100).toFixed(2);
      return format ? format.replace("{{amount}}", price) : `$${price}`;
    };

    // 使用兼容写法
    const price = window.theme?.Currency?.formatMoney
      ? window.theme.Currency.formatMoney(variant.price, window.theme.strings?.moneyFormat || "${{amount}}")
      : formatMoney(variant.price);
    let comparePrice = "";
    if (!!variant.compare_at_price && variant.price < variant.compare_at_price) {
      comparePrice = window.theme?.Currency?.formatMoney
        ? window.theme.Currency.formatMoney(
            variant.compare_at_price,
            window.theme.strings?.moneyFormat || "${{amount}}",
          )
        : formatMoney(variant.compare_at_price);
    }

    const sloganHtml = slogan ? `<div class="product-slogan">${slogan}</div>` : "";

    const parser = new DOMParser();
    const descriptionDoc = parser.parseFromString(product.description, "text/html");
    const descriptionUl = descriptionDoc.querySelector("ul");
    if (descriptionUl) {
      const liList = descriptionUl.querySelectorAll("li");
      liList.forEach((li, index) => {
        if (index >= 3) {
          li.remove();
        }
      });
    }
    const descriptionHtml = descriptionUl?.outerHTML || "";

    /* Change Article Product Card */
    return `
      <div class="blog-product-container ${articleContent ? "has_ul" : ""}">
        <div class="blog-product-card">
          <div class="product-info-image">
            <a href="/products/${product.handle}" target="_blank" >
              <img src="${imageUrl}" alt="${product.title}" style="width: 100%; height: auto;" loading="lazy"/>
            </a>
          </div>
          <div class="product-info-content">
            ${sloganHtml}
            <a href="/products/${product.handle}" target="_blank" class="title-h3">
              <h3>${product.title}</h3>
            </a>
            <div class="product-info-stars">
              <div class="jdgm-widget jdgm-preview-badge">
                  ${badgeHtml}
              </div>
            </div>
            <div class="product-info-description">
              ${descriptionHtml}
            </div>
            <p class="product-price">
              <span class="on-sale-price">${price}</span>
              ${comparePrice ? `<span class="compare-at-price">${comparePrice}</span>` : ""}
            </p>
            <div class="product-actions">
              <button class="buy-now" data-variant-id="${variant.id}">Shop Now</button>
              <button class="add-to-cart" data-variant-id="${variant.id}" style="display: none;">Add To Cart</button>
              <a href="/products/${product.handle}" target="_blank" class="view-specs">View Specs</a>
            </div>
          </div>
        </div>
        <div class="blog-product-promotion-banner">${articleCardContent}</div>
      </div>
    `;
  }

  function generateStarsHtml(rating) {
    const maxStars = 5;
    let starsHtml = "<div class='card-star'>";
    let current = Math.min(Math.max(Number(rating) || 0, 0), maxStars);
    let starIndex = 0;
    const clipIdPrefix = `article-star-clip-${Date.now()}-${Math.random().toString(36).slice(2)}`;

    const renderStarSvg = (fillRatio) => {
      const safeFillRatio = Math.min(Math.max(fillRatio, 0), 1);
      const starPath =
        "M9 12.9525L13.635 15.75L12.405 10.4775L16.5 6.93L11.1075 6.4725L9 1.5L6.8925 6.4725L1.5 6.93L5.595 10.4775L4.365 15.75L9 12.9525Z";

      if (safeFillRatio >= 1) {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="${starPath}" fill="#F5A623"/></svg>`;
      }

      starIndex += 1;
      const clipId = `${clipIdPrefix}-${starIndex}`;
      const clipWidth = (18 * safeFillRatio).toFixed(2);

      return `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><defs><clipPath id="${clipId}"><rect x="0" y="0" width="${clipWidth}" height="18"/></clipPath></defs><path d="${starPath}" fill="#F5A623" clip-path="url(#${clipId})"/></svg>`;
    };

    while (current > 0) {
      if (current >= 1) {
        starsHtml += `<div class='star'>${renderStarSvg(1)}</div>`;
      } else {
        starsHtml += `<div class='star'>${renderStarSvg(current)}</div>`;
      }
      current--;
    }
    starsHtml += "</div>";
    return starsHtml;
  }

  function bindAddToCartEvents(card, product) {
    card.querySelector(".add-to-cart").addEventListener("click", function (e) {
      const variantId = this.getAttribute("data-variant-id");
      addToCart(variantId, 1, () => {
        alert("Added To Cart！");
      });
    });

    card.querySelector(".buy-now").addEventListener("click", function (e) {
      const variantId = this.getAttribute("data-variant-id");
      addToCart(variantId, 1, () => {
        window.location.href = "/checkout";
      });
    });
  }

  function addToCart(variantId, quantity, callback) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => {
        if (response.ok) return callback();
        throw new Error("Add purchase failed");
      })
      .catch((error) => {
        alert("error adding to cart");
        console.error(error);
      });
  }
}

function replaceRatingsCard(articleContent) {
  const shortcodeRegex = /\[ratings\b(?:\s+"[^"]+"\s*=\s*"[^"]*")+\s*\]/g;
  const attributeRegex = /"([^"]+)"\s*=\s*"([^"]*)"/g;
  const contentHtml = articleContent.innerHTML;
  const newContentHtml = contentHtml.replace(shortcodeRegex, (code) => {
    const attributes = [...code.matchAll(attributeRegex)].map(([, key, value]) => ({
      key: key.trim(),
      value: value.trim(),
    }));
    const cardTitle = attributes.find(({ key }) => key.toLowerCase() === "ratingscardtitle")?.value || "";
    const ratings = attributes
      .filter(({ key }) => key.toLowerCase() !== "ratingscardtitle")
      .filter(({ value }) => isNumericRating(value))
      .map(({ key, value }) => ({
        key,
        rawValue: value,
        numberValue: Number(value),
      }))
      .filter(({ numberValue }) => Number.isFinite(numberValue));

    if (!cardTitle && ratings.length === 0) {
      return "";
    }

    const ratingRowsHtml = ratings
      .map(({ key, rawValue, numberValue }) => {
        const percentage = Math.min(Math.max(numberValue, 0), 10) * 10;

        return `
          <div class="ratings-card-row">
            <div class="ratings-card-label">${escapeHtml(key)}</div>
            <div class="ratings-card-track">
              <div class="ratings-card-progress" style="width: ${percentage}%;"></div>
            </div>
            <div class="ratings-card-value">${escapeHtml(rawValue)}</div>
          </div>
        `;
      })
      .join("");

    return `
      <div class="ratings-card">
        <div class="ratings-card-title">${escapeHtml(cardTitle)}</div>
        <div class="ratings-card-list">
          ${ratingRowsHtml}
        </div>
      </div>
    `;
  });
  articleContent.innerHTML = newContentHtml;
}

function replaceTableBadge(articleContent) {
  const shortcodeRegex = /\[badge\b[\s\S]*?\]/g;
  const attributeRegex = /(?:"([^"]+)"|([^\s="]+))\s*=\s*"([^"]*)"/g;
  const contentHtml = articleContent.innerHTML;
  const newContentHtml = contentHtml.replace(shortcodeRegex, (code) => {
    const normalizedCode = code.replace(/[“”]/g, '"');
    const attributes = [...normalizedCode.matchAll(attributeRegex)].map(([, quotedKey, unquotedKey, value]) => ({
      key: (quotedKey || unquotedKey).trim(),
      value: value.trim(),
    }));
    const badgeText = attributes.find(({ key }) => key.toLowerCase() === "text")?.value || "";

    if (!badgeText) {
      return "";
    }

    return `
      <span class="table-badge">
        <span class="table-badge-text">${escapeHtml(badgeText)}</span>
      </span>
    `;
  });
  articleContent.innerHTML = newContentHtml;
}

function escapeHtml(value) {
  const escapeMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  };

  return String(value).replace(/[&<>"']/g, (char) => escapeMap[char]);
}

function isNumericRating(value) {
  return /^-?(?:\d+|\d*\.\d+)$/.test(String(value).trim());
}

async function getJudgeBadge(handle) {
  try {
    const response = await fetch(`/products/${handle}`);
    if (!response.ok) return "";

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const badge = doc.querySelector(".jdgm-preview-badge");
    return badge ? badge.innerHTML : "";
  } catch (e) {
    console.error("Load Judge.me badge failed", e);
    return "";
  }
}

class ArticleNav extends HTMLElement {
  connectedCallback() {
    if (this.isConnected) {
      this.render();
    }
  }

  render() {
    const navList = this.querySelector(".article-nav-lists");
    const articleBody = this.closest(".article-body");
    const articleContent = articleBody?.querySelector(".article-content") || document.querySelector(".article-content");
    const headings = articleContent
      ? Array.from(articleContent.querySelectorAll("h2[data-blog-title], h3[data-blog-title]"))
      : [];
    const visibleHeadings = headings.filter((heading) => heading.textContent.trim());

    if (!navList || !articleContent || visibleHeadings.length === 0) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    navList.replaceChildren();

    const headingSet = new Set(visibleHeadings);
    const usedIds = new Set(
      Array.from(document.querySelectorAll("[id]"))
        .filter((element) => !headingSet.has(element))
        .map((element) => element.id),
    );
    const navTree = this.createNavTree(
      visibleHeadings.map((heading, index) => {
        const level = Number(heading.tagName.slice(1));
        const id = this.ensureHeadingId(heading, index, usedIds);

        return {
          id,
          level,
          text: heading.textContent.trim(),
          children: [],
        };
      }),
    );

    this.appendNavItems(navTree, navList);
  }

  ensureHeadingId(heading, index, usedIds) {
    if (heading.id && !usedIds.has(heading.id)) {
      usedIds.add(heading.id);
      return heading.id;
    }

    const baseId = this.slugify(heading.id || heading.textContent) || `article-heading-${index + 1}`;
    let id = baseId;
    let duplicateIndex = 2;

    while (usedIds.has(id)) {
      id = `${baseId}-${duplicateIndex}`;
      duplicateIndex += 1;
    }

    heading.id = id;
    usedIds.add(id);

    return id;
  }

  slugify(text) {
    return text
      .trim()
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9\u4e00-\u9fa5]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  createNavTree(items) {
    const root = { level: 1, children: [] };
    const stack = [root];

    items.forEach((item) => {
      while (stack.length > 1 && item.level <= stack[stack.length - 1].level) {
        stack.pop();
      }

      stack[stack.length - 1].children.push(item);
      stack.push(item);
    });

    return root.children;
  }

  appendNavItems(items, list) {
    items.forEach((item) => {
      const listItem = document.createElement("li");
      const link = document.createElement("a");

      listItem.className = `article-nav-item article-nav-item--h${item.level}`;
      link.className = "article-nav-link";
      link.href = `#${item.id}`;
      link.textContent = item.text;

      listItem.appendChild(link);

      if (item.children.length > 0) {
        const childList = document.createElement("ul");
        childList.className = "article-nav-sublist";
        this.appendNavItems(item.children, childList);
        listItem.appendChild(childList);
      }

      list.appendChild(listItem);
    });
  }
}

if (!customElements.get("article-nav")) {
  customElements.define("article-nav", ArticleNav);
}

function productSetIframeStyleInject(container = document) {
  const root = container instanceof Element ? container : document.body;
  if (!root) return;

  const styleId = "article-product-set-iframe-style";
  const styleContent = `
@font-face {
  font-family: 'MiSans Latin';
  src: url('https://cdn.shopify.com/s/files/1/0553/1320/3405/files/MiSansLatinVF.ttf?v=1765343549');

  font-display: swap;
}

.shopify-buy__collection-products {
  margin-left: 0;
  display: grid;

  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.shopify-buy__collection-products div.shopify-buy__product {
  min-width: unset;
  max-width: unset;
  width: 100%;
  border: 1px solid #E5E2DB;
  border-radius: 12px;
  background: #FFF;
  margin-left: 0;
  margin-top: 0;
  display: flex;
  flex-direction: column;
}

.shopify-buy__product__variant-img {
  margin-bottom: 16px;
}

.shopify-buy__product__title {
  padding: 0 20px;
  text-align: start;
  margin-bottom: 20px;
  font-family: 'MiSans Latin';
  color: #5A5A5A;
  font-size: 16px;
  font-style: normal;
  font-weight: 630;
  line-height: 175%;
  flex: 1;
}

.shopify-buy__product__price {
  padding: 0 20px;
  margin-bottom: 20px;
  text-align: start;
}

.shopify-buy__product__actual-price {
  color: #5A5A5A;
  font-family: "MiSans Latin";
  font-size: 16px;
  font-style: normal;
  font-weight: 630;
  line-height: 175%;
}

.shopify-buy__product__compare-price {
  color: #606060;
  font-family: "MiSans Latin";
  font-size: 12px;
  font-style: normal;
  font-weight: 330;
  line-height: 175%;
  text-decoration-line: line-through;
  opacity: 1;
}

.shopify-buy__product .shopify-buy__btn-wrapper {
  padding: 0 20px;
  margin-bottom: 20px;
}

.shopify-buy__btn {
  border-radius: 6px;
  background: #1A1A1A;
  background-color: #1A1A1A;
  padding: 9px;
  display: flex;
  justify-content: center;
  color: #FFF;
  text-align: center;
  font-family: "MiSans Latin";
  font-size: 16px;
  font-style: normal;
  font-weight: 630;
  line-height: 131.25%;
  letter-spacing: 0.36px;
  width: 100%;
}
@media (min-width: 597px) and (max-width: 776px) {
  .shopify-buy__collection-products {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (min-width: 508px) and (max-width: 596px) {
  .shopify-buy__collection-products {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 507px) {
  .shopify-buy__collection-products {
    grid-template-columns: 1fr;
    gap: 3.1vw;
  }

  .shopify-buy__product__variant-img {
    margin-bottom: 2.1vw;
  }

  .shopify-buy__product__title {
    font-weight: 700;
    font-size: clamp(20px, 4.26vw, 32px);
    line-height: 153%;
  }


  .shopify-buy__product__actual-price {
    font-weight: 700;
    font-size: clamp(18px, 3.73vw, 28px);
  }

  .shopify-buy__product__compare-price {
    font-weight: 380;
    font-size: clamp(12px, 3vw, 16px);
  }

  .shopify-buy__product .shopify-buy__btn-wrapper {
    margin-bottom: 8vw;
    padding: 0 2.66vw;
  }

  .shopify-buy__btn {
    letter-spacing: 0.48px;
    font-weight: 700;
    font-size: clamp(14px, 2.66vw, 20px);
    line-height: 140%;
  }
}
  `;

  const injectStyle = (iframe) => {
    try {
      const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDocument?.head || iframeDocument.getElementById(styleId)) return;

      const style = iframeDocument.createElement("style");
      style.id = styleId;
      style.textContent = styleContent;
      iframeDocument.head.appendChild(style);
    } catch (error) {
      console.warn("Unable to inject product set iframe styles.", error);
    }
  };

  const handleIframe = (iframe) => {
    if (iframe.dataset.articleProductSetStyleBound === "true") return;
    iframe.dataset.articleProductSetStyleBound = "true";

    let iframeDocument;
    try {
      iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
    } catch (error) {
      iframeDocument = null;
    }

    if (iframeDocument?.readyState === "complete") {
      injectStyle(iframe);
      return;
    }

    iframe.addEventListener("load", () => injectStyle(iframe), { once: true });
  };

  root.querySelectorAll(".shopify-buy-frame--productSet iframe").forEach(handleIframe);

  if (root.dataset.articleProductSetIframeObserver === "true") return;
  root.dataset.articleProductSetIframeObserver = "true";

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches(".shopify-buy-frame--productSet iframe")) {
          handleIframe(node);
        }

        node.querySelectorAll(".shopify-buy-frame--productSet iframe").forEach(handleIframe);
      });
    });
  });

  observer.observe(root, { childList: true, subtree: true });
}
